import { Link } from "react-router-dom";
import { MapPin, Play, BadgeCheck } from "lucide-react";
import { fileUrl } from "./ImageUpload";

const FALLBACK = "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=900&q=80";

function resolveImg(v) {
  if (!v) return null;
  if (v.startsWith("http") || v.startsWith("/")) return v;
  return fileUrl(v);
}

export default function ArtistCard({ artist }) {
  const img = resolveImg(artist.cover_image) || resolveImg(artist.photos?.[0]) || FALLBACK;
  return (
    <article
      data-testid={`artist-card-${artist.id}`}
      className="card-mc flex flex-col group relative overflow-hidden transition-transform duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(13,27,42,0.14)] hover:border-[hsl(var(--primary))]/40"
    >
      <div className="absolute top-0 inset-x-0 gn-strip h-[2px] z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <Link to={`/artists/${artist.id}`} className="block relative overflow-hidden aspect-square bg-muted">
        <img loading="lazy" src={img} alt={artist.stage_name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        <div className="absolute top-3 left-3">
          <span className="backdrop-blur-md bg-black/50 border border-white/10 text-white font-mono text-[10px] uppercase tracking-wider px-2.5 py-1 rounded-full">{artist.category}</span>
        </div>
        {artist.music_links?.length > 0 && (
          <div className="absolute bottom-3 right-3 w-10 h-10 bg-[hsl(var(--secondary))] flex items-center justify-center rounded-full shadow-[0_4px_16px_rgba(255,138,0,0.45)]">
            <Play className="w-4 h-4 text-white" fill="currentColor" />
          </div>
        )}
      </Link>
      <div className="p-5 flex flex-col gap-3">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display font-semibold text-xl tracking-tight leading-tight flex items-center gap-1.5">
            {artist.stage_name}
            {artist.verified && <BadgeCheck className="w-5 h-5 text-[hsl(var(--primary))] shrink-0" data-testid={`card-verified-${artist.id}`} title="Artiste vérifié" />}
          </h3>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground font-mono uppercase tracking-wider">
          <MapPin className="w-3 h-3" />
          <span>{artist.city}</span>
        </div>
        <div className="pt-3 border-t border-border">
          <Link to={`/artists/${artist.id}`} data-testid={`view-artist-${artist.id}`} className="btn-primary w-full">Solliciter</Link>
        </div>
      </div>
    </article>
  );
}
